export interface SuepCode {
  suepSequenceNumber: number;
}

export interface SuepProfile {
  description?: string
  expressionCode?: string
  itemType?: string
}

export interface ClinicalNoteSuep {
  clinicalNoteType: string
}

export interface SuepModelsTemplate {
  name?: string;
  type?: SuepProfileTypes;
}

export enum SuepProfileTypes {
  DIAGNOSIS = 'CD',
  NON_LAB_EXAMS = 'EN',
  LAB_EXAMS = 'EX',
  VITAL_SIGNS = 'ST',
  CLINICAL_NOTES = 'EV',
  INTAKES_OUTPUTS = 'PG',
  HYDRIC_BALANCE = 'BH',
  DEVICES = 'DI',
  WOUNDS_DRESSINGS = 'WD',
  CPOE = 'CP',
  SCORE_INDEXES = 'ER'
}

export enum Screen {
  INTAKES_AND_OUTPUT = 'intakes-outputs',
  HYDRIC_BALANCE = 'hydric'
}

export enum SuepCpoeGroup {
  DIALYSIS = 'dialysis',
  EXAMS_PROCEDURES = 'examsProcedures',
  GASTHERAPY = 'gastherapy',
  HEMOTHERAPY = 'hemotherapy',
  INFUSIONS_MEDICINES = 'infusionsMedicines',
  NURSING_INTERVENTIONS = 'nursingInterventions',
  NUTRITION = 'nutrition',
  RECOMMENDATIONS = 'recommendations'
}

export interface SuepCpoe {
  [SuepCpoeGroup.DIALYSIS]: number;
  [SuepCpoeGroup.EXAMS_PROCEDURES]: number;
  [SuepCpoeGroup.GASTHERAPY]: number;
  [SuepCpoeGroup.HEMOTHERAPY]: number;
  [SuepCpoeGroup.INFUSIONS_MEDICINES]: number;
  [SuepCpoeGroup.NURSING_INTERVENTIONS]: number;
  [SuepCpoeGroup.NUTRITION]: number;
  [SuepCpoeGroup.RECOMMENDATIONS]: number;
}

export const suepProfileTypesOswald: SuepModelsTemplate[] = [
  {
    name: 'panel-clinical-notes',
    type: SuepProfileTypes.CLINICAL_NOTES
  },
  {
    name: 'panel-non-lab-exams',
    type: SuepProfileTypes.NON_LAB_EXAMS
  },
  {
    name: 'panel-diagnosis',
    type: SuepProfileTypes.DIAGNOSIS
  },
  {
    name: 'panel-lab-exams',
    type: SuepProfileTypes.LAB_EXAMS
  },
  {
    name: 'panel-vital-sign',
    type: SuepProfileTypes.VITAL_SIGNS
  },
  {
    name: 'panel-intakes-outputs',
    type: SuepProfileTypes.INTAKES_OUTPUTS
  },
  {
    name: 'panel-hydric-balance',
    type: SuepProfileTypes.HYDRIC_BALANCE
  },
  {
    name: 'panel-devices',
    type: SuepProfileTypes.DEVICES
  },
  {
    name: 'panel-wounds-dressings',
    type: SuepProfileTypes.WOUNDS_DRESSINGS
  },
  {
    name: 'panel-cpoe',
    type: SuepProfileTypes.CPOE
  },
  {
    name: 'panel-score-indexes',
    type: SuepProfileTypes.SCORE_INDEXES
  }
]

export enum ParamAccess {
  ONE = '1'
}